import { UI, FONT } from "../constants/tokens";
import { fmtPct } from "../utils/formatters";
import { dateNumeric } from "../utils/formatDate";
import { FOMC_SOURCE } from "../constants/fomc";
import LTR from "./LTR";
import { Skeleton as Skel, Loading } from "./Skeleton";

// ─── "בשבועיים הקרובים" (sprint 19, stage 4) ────────────────────────────────
// At most three events from the next fourteen days, nearest first: the
// reports of the holdings and of the watchlist (Finnhub), and the market's
// own dates (FRED releases, the FOMC list, NYSE holidays). A report says how it touches the portfolio · the
// holding's weight, and when in the day the company reports, as Finnhub
// states it. The whole list is in the calendar, one tap away.

export const UPCOMING_MAX = 3;

// Finnhub's `hour` for an earnings date.
const REPORT_HOUR = { bmo: "לפני הפתיחה", amc: "אחרי הסגירה", dmh: "במהלך המסחר" };

// `held`: the portfolio's symbols · `weights`: their share of its value, for
// those with a price.
export default function UpcomingCard({ rows, held = new Set(), weights = {}, cardStyle, actionStyle, onOpenCalendar }) {
  if (rows === null) {
    return <div style={cardStyle}><Loading><Skel w="70%" h={14} mb={8}/><Skel w="50%" h={14}/></Loading></div>;
  }
  const shown = rows.slice(0, UPCOMING_MAX);
  return (
    <div style={cardStyle} data-upcoming>
      {shown.length === 0 ? (
        <div style={{ fontSize: 14, color: UI.text.secondary }}>
          אין דוחות של החזקות או של מניות במעקב, פרסומי מאקרו או ימים בלי מסחר בשבועיים הקרובים
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {shown.map(row => {
            const w = row.kind === "report" ? weights[row.symbol] : null;
            // The report list holds the watchlist's symbols too.
            const where = !held.has(row.symbol) ? "ברשימת המעקב"
              : Number.isFinite(w) ? <>בתיק שלך · משקל <LTR className="si-num">{fmtPct(w, { decimals: 1, signed: false })}</LTR></>
              : "בתיק שלך";
            const tie = row.kind === "report" ? [where, REPORT_HOUR[row.hour]].filter(Boolean) : [];
            return (
              <div key={row.key}>
                <div style={{ display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }}>
                  {row.kind === "report" ? (
                    <>
                      <LTR style={{ fontSize: 15, fontWeight: 800, color: UI.text.primary, fontFamily: FONT.latin }}>{row.symbol}</LTR>
                      <span style={{ fontSize: 13, color: UI.text.muted }}>דוח רבעוני</span>
                    </>
                  ) : (
                    <>
                      <span style={{ fontSize: 14, fontWeight: 700, color: UI.text.primary }}>{row.title}</span>
                      <span style={{ fontSize: 13, color: UI.text.muted }}>{row.kindLabel || (row.kind === "macro" ? "פרסום מאקרו" : "לוח המסחר")}</span>
                    </>
                  )}
                  <span style={{ marginInlineStart: "auto", fontSize: 13.5, fontWeight: 700, color: UI.text.primary }}>{row.when}</span>
                </div>
                {tie.length > 0 && (
                  <div style={{ fontSize: 12.5, color: UI.text.secondary, marginTop: 2 }}>
                    {tie.map((t, i) => <span key={i}>{i ? " · " : ""}{t}</span>)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div style={{ fontSize: 11.5, color: UI.text.muted, marginTop: 12, lineHeight: 1.6 }}>
        {rows.length > shown.length && <>מוצגים <LTR className="si-num">{shown.length}</LTR> הקרובים מתוך <LTR className="si-num">{rows.length}</LTR> · </>}
        מקורות: דוחות וימי מסחר · <LTR>Finnhub</LTR> · פרסומי מאקרו · <LTR>FRED</LTR> · ישיבות ה-FOMC · רשימה קבועה מלוח הפד, נבדקה <LTR>{dateNumeric(FOMC_SOURCE.checked)}</LTR>
      </div>
      <button type="button" onClick={onOpenCalendar} style={actionStyle}>ליומן המלא<span aria-hidden style={{ fontSize: 16, lineHeight: 1 }}>←</span></button>
    </div>
  );
}
